import { render, staticRenderFns } from "./baxq2.vue?vue&type=template&id=7aef0a2c&scoped=true&"
import script from "./baxq2.vue?vue&type=script&lang=js&"
export * from "./baxq2.vue?vue&type=script&lang=js&"
import style0 from "./baxq2.vue?vue&type=style&index=0&id=7aef0a2c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7aef0a2c",
  null
  
)

export default component.exports